import React from 'react'

export const ArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4.5 15.75L12 8.25L19.5 15.75"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const EyeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M2.03601 12.322C1.967 12.1146 1.967 11.8904 2.03601 11.683C3.42301 7.51 7.36001 4.5 12 4.5C16.638 4.5 20.573 7.507 21.963 11.678C22.033 11.885 22.033 12.109 21.963 12.317C20.577 16.49 16.64 19.5 12 19.5C7.36201 19.5 3.42601 16.493 2.03601 12.322Z"
      stroke="#2F2F2F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12Z"
      stroke="#2F2F2F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M3 16.5V18.75C3 19.3467 3.23705 19.919 3.65901 20.341C4.08097 20.7629 4.65326 21 5.25 21H18.75C19.3467 21 19.919 20.7629 20.341 20.341C20.7629 19.919 21 19.3467 21 18.75V16.5M16.5 12L12 16.5M12 16.5L7.5 12M12 16.5V3"
      stroke="#2F2F2F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const AylaIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
  >
    <path
      d="M4 28.5L17.3333 15.1667M24 8.5L20.6667 11.8333"
      stroke="#2F2F2F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6667 3.16675L13.9271 6.57299L17.3333 7.83341L13.9271 9.09384L12.6667 12.5001L11.4062 9.09384L8 7.83341L11.4062 6.57299L12.6667 3.16675Z"
      stroke="#2F2F2F"
      strokeLinejoin="round"
    />
    <path
      d="M25.3333 13.8333L26.0536 15.7797L28 16.4999L26.0536 17.2202L25.3333 19.1666L24.6131 17.2202L22.6667 16.4999L24.6131 15.7797L25.3333 13.8333Z"
      stroke="#2F2F2F"
      strokeLinejoin="round"
    />
  </svg>
)

export const DocumentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
  >
    <path
      d="M26 19.5V16C26 14.8065 25.5259 13.6619 24.682 12.818C23.8381 11.9741 22.6935 11.5 21.5 11.5H19.5C19.1022 11.5 18.7206 11.342 18.4393 11.0607C18.158 10.7794 18 10.3978 18 10V8C18 6.80653 17.5259 5.66193 16.682 4.81802C15.8381 3.97411 14.6935 3.5 13.5 3.5H11M11 20.5H21M11 24.5H16M14 3.5H7.5C6.672 3.5 6 4.172 6 5V28C6 28.828 6.672 29.5 7.5 29.5H24.5C25.328 29.5 26 28.828 26 28V15.5C26 12.3174 24.7357 9.26516 22.4853 7.01472C20.2348 4.76428 17.1826 3.5 14 3.5Z"
      stroke="#2F2F2F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
